<template lang="html">
  <section
    class="popup fixed w-full h-full z-50 top-0 left-0 bg-accent-100 flex lg:items-center lg:justify-center"
    v-if="isVisible"
  >
    <div class="w-full lg:h-full overflow-auto">
      <div
        class="flex flex-col lg:grid lg:grid-cols-2 items-center justify-center md:gap-10 lg:h-full"
      >
        <div class="h-80 md:h-150 lg:h-full overflow-hidden w-full">
          <slot name="image"></slot>
        </div>
        <div class="pb-4 px-6 py-6 lg:py-10 w-full">
          <div class="max-w-xl mx-auto lg:mx-0">
            <div
              class="flex items-center justify-between border-b border-gray-300 py-6"
            >
              <h2 class="text-4xl">{{ config.name }} {{ apartment.id }}</h2>
              <Status :status="apartment.status" large />
            </div>

            <Detail
              v-for="item in apartment.details"
              :label="item.label"
              :key="item.label"
              >{{ item.value }}</Detail
            >
            <Detail label="Karta lokalu" v-if="apartment.download">
              <a
                :href="apartment.download"
                target="_blank"
                class="flex items-center gap-1"
              >
                <DownloadIcon /> Pobierz</a
              >
            </Detail>

            <div class="border-t-2 border-gray-300 pt-6">
              <slot name="form"></slot>
            </div>

            <div
              class="mt-10 hidden md:block"
              v-if="config.phone || config.email"
            >
              <div class="text-xl">Skontaktuj się z nami</div>
              <div class="flex items-center gap-4 mt-5 content--accent">
                <a
                  :href="`mailto:${config.email}`"
                  class="icon-mail"
                  v-show="config.email"
                  >{{ config.email }}</a
                >
                <a
                  :href="`tel:${config.phone}`"
                  class="icon-phone"
                  v-show="config.phone"
                  >{{ config.phone }}</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <button
      class="absolute top-6 right-6 w-12 h-12 bg-white rounded-full flex items-center justify-center shadow-sm md:w-16 md:h-16"
      @click="$emit('closePopup')"
    >
      <svg
        class="w-6 h-6 md:w-8 md:h-8"
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M25 7L7 25"
          stroke="#232C32"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M25 25L7 7"
          stroke="#232C32"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </button>
  </section>
</template>

<script>
import Detail from './Detail.vue';
import Status from './Status.vue';
import DownloadIcon from '../../DownloadIcon.vue';
export default {
  props: ['apartment', 'isVisible', 'config'],
  components: {
    Detail,
    Status,
    DownloadIcon,
  },
  updated() {
    let form = document.querySelector(`.popup form.wpcf7-form`);
    if (form) {
      wpcf7.init(form);
      $('#houseSelection').val(this.apartment.id);
      jQuery('.apartment-form form.wpcf7-form').each(function () {
        $(this).find('span.ajax-loader').last().remove();
      });
    }
  },

  methods: {
    handleFormOpen() {
      this.$emit('openForm', this.apartment.id);
    },
  },
};
</script>

<style lang="css" scoped></style>
